import React from "react";
// import SvgIconElementUI from "../../components/SvgIconElement/SvgIconElementUI";
import * as S from "./CancellationPolicyStatus.styles";

interface ICancellationPolicy {
	cancellationData: Array<IData>;
};

interface IData {
	title: string;
	sub_title: string;
	icon: string;
	color: string;
};

const CancellationPolicyStatusUI: React.FC<ICancellationPolicy> = ({cancellationData = []}) => {
  return (
    <>
      {cancellationData?.map(({ title = '', sub_title = '', icon = '' , color = '' }, index) => (
        <S.CnclPolicyList key={`CnclPolicyList${index}`} bc={(index === cancellationData.length - 1) ? '' : color}>
          {icon && (
            <span className="policyIcon">
              <img src={icon} style={{ height: '30px' }} />
            </span>
          )}
          <div>
            {title ? <h5>{title}</h5> : null}
            {sub_title ? <p>{sub_title}</p> : null}
          </div>
        </S.CnclPolicyList>
      ))}
    </>
  );
};

export default CancellationPolicyStatusUI;
